import {StartInferenceRequest} from '../../types/deployment/InferenceRequest';
import {startDeploymentStateless} from '../../store/prodDeployments/dashboard';
import {Deployment} from '../../types/deployment/DeploymentResponse';
import {
  getDeploymentNode,
  NodeSource,
  ProductionNode,
} from '../../api/deployment/DeploymentNodes';
import {assertResponseBody} from '../../api/request';

export const useEdgeInference = (setDeployment: (deployment?: Deployment) => void) => {
  const handleEdgeInferenceStop = async (callback: () => void) => {
    setDeployment(undefined);
    callback();
  };

  const handleEdgeInferenceStart = async (config: StartInferenceRequest) => {
    startDeploymentStateless(config)
      .then(result => {
        setDeployment(result);
        if (config.onStartDeploy) {
          config.onStartDeploy();
        }
      })
      .catch(e => {
        if (config.onError) {
          config.onError(e);
        }
      });
  };

  const fetchDeploymentNode = async (
    onDeploymentNodeReceived: (deploymentNode?: ProductionNode) => void,
    onDeviceListReceived: (devices: NodeSource[]) => void,
    deploymentId?: string
  ) => {
    if (!deploymentId) {
      return;
    }
    const deploymentNode = await assertResponseBody(getDeploymentNode(deploymentId));
    if (deploymentNode && deploymentNode.status === 'ONLINE') {
      onDeploymentNodeReceived(deploymentNode);
      const devices = deploymentNode.sources || [];
      onDeviceListReceived(devices);
    }
  };

  return {handleEdgeInferenceStart, handleEdgeInferenceStop, fetchDeploymentNode};
};
